import React, {useState, useEffect} from 'react';
import './App.css';
import ModelCard from './components/ModelCard'
import AddModelForm from './components/AddModelForm';
import NavBar from './components/NavBar';
import Footer from './components/Footer';

  function App() {
    const [loading, setLoading] = useState(true);
    const [models, setModels] =useState([]);
    const fetchModels = async () => {
      try{
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/models`);
        const data = await response.json();
        setModels(data);
      } catch (error) {
        console.error ('Error fetching models:', error);
      } finally {
        setLoading(false);
      }
    };
    const handleModelAdded = (newModel) => {
      setModels(prev => [...prev, newModel]);
    };
    useEffect (() =>{
      fetchModels();
    }, []);
    
    return(
      <>
      <NavBar />
      <div className="min-h-screen bg-gray-100 p-8">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Model Platform
        </h1>
        
        <AddModelForm onModelAdded={handleModelAdded}/>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="text-xl text-gray-600">Loading models...</div>
          </div>
        ) : models.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-xl text-gray-600">No models yet. Add the first one!</p>
          </div>
        ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {models.map(model => (
            <ModelCard key={model._id} model={model}/>
          ))} 
        </div>
      )}
      </div>
      <Footer />
    </>
    );
  }
export default App;